import { MarketingCalendarEventController } from './marketing-calendar-event.controller'

function marketingCalendarEvent () {
  return {
    restrict: 'E',
    scope: {
      event: '<',
      viewMode: '<',
      originModule: '<'
    },
    templateUrl: '/workflow/directives/marketing-calendar-event/marketing-calendar-event.html?$$REVISION$$',
    controller: MarketingCalendarEventController
  }
}

export { marketingCalendarEvent }
